<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>Stock transfer</h1>
                    <hr>


                    <template>
                        <!-- Search qc number -->
                        <v-layout justify-center>
                            <v-flex xs2 text-xs-right my-4><h3>Input qc number:</h3></v-flex>
                            <v-flex xs2 pa-1 px-2>
                                <v-text-field v-model="searchQcNo" ref="searchQcNo" @change="getQCNumber" ></v-text-field>
                            </v-flex>
                            <v-flex xs2 text-xs-right my-4><h3>Input item code:</h3></v-flex>
                            <v-flex xs2 pa-1 px-2>
                                <v-text-field v-model="searchCode" ref="searchCode" @input="uppercase" @change="getProductCode" ></v-text-field>
                            </v-flex>
                        </v-layout>
                            <!-- <v-flex xs2 my-2>
                                <v-btn @click="searchQcNumber">
                                    <v-icon>search</v-icon>
                                </v-btn>
                            </v-flex> -->
                        
                            
                        
                        <template v-if="showQC">
                        
                            <v-list justify-center >
                               
                                <v-layout class="my-template" indigo darken-5>
                                    <v-flex xs3 mr-2>
                                        <span class="subtitle"><font color="white"><strong>QcNumber</strong></font></span>
                                    </v-flex>
                                    <v-flex xs2 mr-1>
                                        <span class="subtitle"><font color="white"><strong>Code</strong></font></span>
                                    </v-flex>
                                    <v-flex xs1>
                                        <span class="subtitle"><font color="white"><strong>Frame</strong></font></span>
                                    </v-flex>
                                    <v-flex xs1>
                                        <span class="subtitle"><font color="white"><strong>Front</strong></font></span>
                                    </v-flex>
                                    <v-flex xs3>
                                        <span class="subtitle"><font color="white"><strong>Warehouse</strong></font></span>
                                    </v-flex>
                                    
                                    <v-flex xs3>
                                        <v-btn @click="closeQC" color="gray">
                                            <v-icon dark>close</v-icon>
                                        </v-btn> 
                                    </v-flex>
                                           
                                    
                                </v-layout>
                                <hr>    
                                
                                <v-layout
                                    v-for="(item, index) in searchMatches"
                                    :key="index"
                                    
                                    indigo lighten-5
                                >        
                                    <v-flex xs3 mr-2>
                                        {{ item.qc }}
                                    </v-flex>
                                    <v-flex xs2 mr-2>
                                        {{ item.itemCode }}
                                    </v-flex>
                                    <v-flex xs1 mr-1>
                                        {{ item.frame }}
                                    </v-flex>
                                    <v-flex xs1 mr-1>
                                        {{ item.front }}
                                    </v-flex>
                                    <v-flex xs3 mr-3>
                                        {{ item.warehouse }}
                                    </v-flex>
                                        
                                    
                                    <v-flex xs3 mr-3>
                                        <v-btn @click="addQcNumber(item)" :color="buttonColor" :disabled="item.buttonClicked">Add</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-list>
                       
                        </template>
                
                        <hr>
                        <template>
                            <v-layout>
                                <v-flex xs12 text-xs-right my-4><h3>Transfer no:</h3></v-flex>
                                <v-flex xs2 pa-1>
                                    <v-text-field v-model="trNo" readonly  tabindex="-1"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex xs2>
                                    <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                    offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="date" label="Date:" prepend-icon="event" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date" @input="updateTranDate()" @change="gettrNo()"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <template v-if="showDetails">
                                <v-layout justify-center>
                                    <v-flex xs2>
                                        <v-select :items="itemsWarehouse" v-model="warehouse" label="Transfer to Warehouse:"></v-select>
                                    </v-flex>
                                </v-layout>

                                
                                <!-- Header product detail -->
                                <v-layout pt-2 pb-2 indigo lighten-4>
                                    <v-flex xs1 ml-1 mr-2><strong>No</strong></v-flex>
                                    <v-flex xs3 mr-3><strong>Item code</strong></v-flex>
                                    <v-flex xs1 mr-2 pr-1 text-xs-center><strong>Frame</strong></v-flex>
                                    <v-flex xs1 mr-2 text-xs-center><strong>Front</strong></v-flex>
                                    <v-flex xs2 mr-2><strong>Quality control</strong></v-flex>
                                    <v-flex xs2 mr-2><strong>Warehouse</strong></v-flex>
                                    <v-flex xs2 mr-2 text-xs-right><strong>Amount</strong></v-flex>
                                    <v-flex xs2></v-flex>
                                </v-layout>
                                <hr>

                                
                                <v-layout v-for="(item,i) in trDetail" :key="i" collapse>
                                    <v-flex xs1 ml-1 mr-2>                                                            
                                        <!-- <v-text-field :value="i+1" readonly></v-text-field> -->
                                        <font size=3>{{i+1}}</font>
                                    </v-flex>
                                    <v-flex xs3 mr-2>
                                        <v-text-field  v-model="item.itemCode" ref="itemCode"
                                        readonly tabindex="-1"></v-text-field>
                                    </v-flex>
                                    <v-flex xs1 mr-2>
                                        <v-text-field  v-model="item.frame" ref="frame"
                                        readonly tabindex="-1"></v-text-field>
                                    </v-flex>
                                    <v-flex xs1 mr-2>
                                        <v-text-field  v-model="item.front" ref="front"
                                        readonly tabindex="-1"></v-text-field>
                                    </v-flex>
                                    <v-flex xs2 mr-2>
                                        <v-text-field v-model="item.qc" ref="qc" 
                                        readonly tabindex="-1"></v-text-field>
                                    </v-flex>
                                    <v-flex xs2 mr-2>
                                        <v-text-field v-model="item.warehouse" ref="warehouse" 
                                        readonly tabindex="-1"></v-text-field>
                                    </v-flex>
                                    <v-flex xs2 mr-2>
                                        <v-text-field v-model="item.amt"  ref="amt" reverse
                                        readonly></v-text-field>
                                        <!-- <font size=3>
                                            <vue-numeric separator="," :precision="2" v-model="item.amt" class="line" ref="amt"></vue-numeric>
                                        </font> -->
                                    </v-flex>
                                    <v-flex xs2 text-xs-center>
                                        <!-- <v-btn fab small color="primary" @click="addTransferList"
                                            :disabled="item.itemCode == '' || item.frame == '' || item.front == '' || 
                                            item.qc == '' || item.amt == 0 || i != trDetail.length -1"><v-icon dark>add</v-icon>
                                        </v-btn>
                                        <v-btn :disabled="trDetail.length == 1" fab small color="error" @click="delTransferList(item)" tabindex="-1">
                                            <v-icon dark>remove</v-icon>
                                        </v-btn> -->
                                        <v-btn :disabled="trDetail.length == 1" fab small color="error" @click="delTransferList(item)" tabindex="-1">  
                                            <v-icon dark>remove</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <hr>
                                <br><br>

                                <v-layout>
                                    <v-flex xs5>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-textarea outline auto-grow rows="1" v-model="remark" label="Remarks:"></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>        
                                </v-layout>
                                <hr>
                                <br><br>

                                <v-layout align-center column>
                                    <v-flex>
                                        <v-btn @click="addTransfer">
                                            <v-icon dark>save</v-icon>
                                            Save
                                        </v-btn>
                                        <v-btn @click="clearTransfer">
                                            <v-icon dark>clear</v-icon>
                                            Cancel
                                            </v-btn>
                                    </v-flex>
                                </v-layout>

                            </template>
                        </template>
                    </template>
                        
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
//import VueNumeric from 'vue-numeric'
export default  {
    components: {
        mainMenu
        //VueNumeric
    },
    data() {
        return {
            // itemProdCode: [],
            itemCode: '',
            trNo: '',
            menuDate: false,
            date: new Date().toISOString().substr(0,10),
            itemsWarehouse: [],
            warehouse: '',
            
            trDetail: [],
            // itemFrame: [],
            frame: '',
            //itemFront: [],
            front: '',
            //added model
            amt: '',
            qc: '',
            searchQcNo: '',
            searchCode: '',
            showDetails: false,
            itemQC: [],
            searchMatches: [],
            showQC: false,
            stockId: '',
            buttonColor: '#ad9bed',
            unsubscribe: null,
            buttonClicked: false,
            remark: '',
            

        }
    },
    methods: {
        // inputCurrency(item){
        //     if(item.amt != item.amt*1){
        //         let amtSplit = item.amt.split(",")
        //         let sumSplit = ''
        //         for (let i = 0; i < amtSplit.length; i++) {
        //             sumSplit += amtSplit[i]
        //         }
        //         sumSplit = sumSplit*1
        //         item.amt = sumSplit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        //     }
        //     else{
        //         item.amt = item.amt*1
        //         item.amt = item.amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        //     }
        // },

        // Uppercase
        uppercase(){
            this.searchCode = this.searchCode.toUpperCase()
        },

        getProductCode() {
            if (this.searchCode !== '') {
                // console.log("Search Product code: ", this.searchCode)
                let foundData = false

                db.collection("stock").where("itemCode", ">=", this.searchCode).where("itemCode", "<", this.searchCode + '\uf8ff')
                    .onSnapshot(querySnapshot => {
                        // console.log("Inside onSnapshot callback")
                        this.searchMatches = []        
                        
                        querySnapshot.forEach(doc => {
                            let data = doc.data()
                            if (data.status == "Closed") {
                                return
                            } else{
                                foundData = true
                                let docId = doc.id
                                this.stockId = docId
                                const qc = doc.data().qc
                                const itemCode = doc.data().itemCode
                                const frame = doc.data().frame
                                const front = doc.data().front
                                const warehouse = doc.data().warehouse
                                const amt = doc.data().amt
                                this.searchMatches.push({
                                    qc,
                                    itemCode,
                                    frame,
                                    front,
                                    warehouse,
                                    amt,
                                    stockId: docId,
                                    buttonColor: '#ad9bed',
                                    // buttonClicked: false,

                                })
                                this.showQC = true
                            }
                        })
                        if (!foundData) {
                            alert("Data not found")
                            // console.log("Data not found")
                        }
                        
                    })
                    
                    
            } else {
                this.searchMatches = []
            
            }

            
       },
        
        //add new method
        getQCNumber() {
            if (this.searchQcNo !== '') {
                // console.log("Search QC Number:", this.searchQcNo);
                let foundData = false

                db.collection("stock").where("qc", ">=", this.searchQcNo).where("qc", "<", this.searchQcNo + '\uf8ff')
                    .onSnapshot(querySnapshot => {
                        // console.log("Inside onSnapshot callback")
                        this.searchMatches = []        
                        
                        querySnapshot.forEach(doc => {
                            let data = doc.data()
                            if (data.status == "Closed") {
                                return
                            } else{
                                foundData = true
                                let docId = doc.id
                                this.stockId = docId
                                const qc = doc.data().qc
                                const itemCode = doc.data().itemCode
                                const frame = doc.data().frame
                                const front = doc.data().front
                                const warehouse = doc.data().warehouse
                                const amt = doc.data().amt
                                this.searchMatches.push({
                                    qc,
                                    itemCode,
                                    frame,
                                    front,
                                    warehouse,
                                    amt,
                                    stockId: docId,
                                    buttonColor: '#ad9bed',
                                    // buttonClicked: false,

                                })
                                this.showQC = true
                            }
                        })
                        if (!foundData) {
                            alert("Data not found")
                            console.log("Data not found")
                        }
                        
                    })
                    
                    
            } else {
                this.searchMatches = []
            
            }
            
        },

        //add new method 
        addQcNumber(item) {
                //change button color when add button is clicked
                //item.buttonColor = '#ad9bed'
                item.buttonClicked = true
                this.showDetails = true
                                    
                this.trDetail.push({
                    itemCode: item.itemCode,
                    frame: item.frame,
                    front: item.front,
                    amt: item.amt,
                    warehouse: item.warehouse,
                    qc: item.qc,
                    stockId: item.stockId,
                    buttonColor: item.buttonColor
                    
                })       
        },

        //add new method
        closeQC() {
            this.showQC = false
            this.searchQcNo = ''
            this.searchCode = ''
            this.searchMatches = []
        },

        updateTranDate() {
            console.log("Date: ", this.date)
            this.menuDate = false
        },
        gettrNo() {
            
            let year = this.date.substr(0,4)
            let subYear = this.date.substr(2, 2)
            db.collection("counter").doc(year).get()
            .then(doc=>{
                let typeDoc = doc.data().tr + 1
                if (typeDoc<=9999){ 
                    typeDoc = ("000"+typeDoc).slice(-4)
                }
                this.trNo = "TR" + subYear + typeDoc
            })     
        },

        // Get warehouse
        getWarehouse() {
            db.collection("warehouse").get()
            .then(query=>{
                this.itemsWarehouse = []
                query.forEach(doc=>{
                    this.itemsWarehouse.push(doc.data().code + " " + ":" + " " + doc.data().name)
                })
            this.itemsWarehouse.sort()
            this.warehouse = this.itemsWarehouse[0]

            })
        },

        

        // Delete purchase list
        delTransferList(item){
            this.trDetail.splice(this.trDetail.findIndex(detail=>detail==item),1)
        },

        // Add purchase
        addTransfer() {
            this.showQc = false
            let app = this
                let year = this.date.substr(0, 4)
                let DocRef = db.collection("counter").doc(year)
                db.runTransaction((transaction) => {
                    return transaction.get(DocRef).then((Doc) => {
                        if (!Doc.exists) {
                            throw "Document does not exist!"
                        }
                        else {
                            let newTr = Doc.data().tr + 1
                            transaction.update(DocRef, {
                                tr: newTr,

                            })
                        }
                    })
                })
                    .then(() => {
                        let i = 0
                        let transferAdded = false
                        // update warehouse to stock
                        app.trDetail.forEach((rec) => {
                            //console.log("Updating document with ID:", rec.stockId)
                            
                            // db.collection("stock").add({
                                //addDoc(collection(db, "stock"), {
                            db.collection("stock").doc(rec.stockId).update({
                                
                                warehouse: app.warehouse,
                              
                            })
                            
                                .then(() => {
                                    // console.log("After update") 
                                    i++
                                    callback()
                                })
                               
                        })
                        let callback = function
                            callback() {
                            if (!transferAdded && i === app.trDetail.length) {
                                //Add transfer data only once when all stock updates are completed
                                transferAdded = true
                                const transferData = {
                                    trNo: app.trNo,
                                    date: app.date,
                                    details: app.trDetail.map((item) => ({
                                        itemCode: item.itemCode,
                                        frame: item.frame,
                                        front: item.front,
                                        qc: item.qc,
                                        amt: item.amt
                                        })),
                                    remark: app.remark,
                                    warehouse: app.warehouse,
                                }
                                db.collection("transfer")
                                    .add(transferData)
                                    .then(() => {
                                        // console.log("Transfer data added successfully")
                                        alert("Success.")
                                        app.clearTransfer()
                                    })
                                    .catch((error) => {
                                        console.error("Error adding transfer data: ", error)
                                    })
                                
                                
                            }
                        }
                    })
            // }
        },

        // Clear web page
        clearTransfer(){
            this.gettrNo()
            this.date = new Date().toISOString().substr(0,10)
            this.warehouse = this.itemsWarehouse[0]
            this.trDetail = []
            this.searchQcNo = ''
            this.searchCode = ''
            this.remark = ''
            this.showDetails = false
            this.showQC = false
            this.searchMatches = []
            // this.addTransferList()
           
        },

        // If the date has changed, focus item code again.
        // focusTrdetail(){
        //     this.$nextTick(()=>{this.$refs.searchQuery.focus()})
        // },
    },
    computed: {
        sumAmt(){
            return this.trDetail.reduce((total,item)=>total+(item.amt),0)
        },
    },
    mounted() {    
        this.gettrNo()
        this.getWarehouse()    
    }
}

</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  /* text-align: left; */
  padding: 0.5%;
  /* padding: 10px; */
}
.line{
    border-bottom: 1px solid gray;
    text-align: right;
    width: 100%;
}
.my-input input{
  text-transform: uppercase;
}
.numeric{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid gray;
    /* padding: 1%; */
}
.sumNumeric{
    text-align: right;
    width: 100%;
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    /* padding: 2%; */
}

.my-template{
    background-color: #cbbebe;
}
.my-template-background{
    background-color: #eeeded;
}
</style>
